import logo from './HSBC.svg';

const HSBCLogo = () => {
    return <img src={logo} alt="HSBC logo" />;
};

HSBCLogo.borderColor = '#dbdbdb';
HSBCLogo.textColor = '#333333';
HSBCLogo.backgroundColor = '#ededed';

// eslint-disable-next-line import/no-default-export
export default HSBCLogo;
